import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  CircularProgress,
  FlatButton,
  Divider
} from 'material-ui';

import {
  LoadingDialog,
  AlertDialog,
  AlertDialogOneButton,
  Stepper,
} from 'imports/DesignImports';

import {
  PostulationFormWithSteps,
  CompanyConventions,
} from 'imports/ComponentsImports';

const styles = {
  pageContainer: {
    padding: '0em 0em 0.5em 1em',
    color: '#212F55'
  },
  textContainer: {
    padding: '0em 0em 0.2em 2em',
    color: '#212F55'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
  },
  button: {
    backgroundColor: '#11AB99',
    color: 'white',
    fontWeight: 'normal',
    borderRadius: '0px',
    fontFamily: 'Lato'
  },
  redButton: {
    backgroundColor: '#BA0F0F',
    color: 'white',
    fontWeight: 'normal',
    borderRadius: '0px',
    fontFamily: 'Lato'
  },
  instructionsParagraph: {
    width: '80%',
  }
}

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ProjectPostulationView extends Component {

  constructor(props){
    super(props);
    this.state = {
      information: {},
      loading: true,
      error: false,
      economicImpact: 1,
      solutionType: [],
      benefitType: [],
      novelty: "Nuevo para la empresa",
      implementationDate: null,
      name: '',
      leaderFirstName: '',
      leaderLastName: '',
      leaderEmail: '',
      problem: '',
      solution: '',
      benefits: '',
      sponsor: '',
      area: '',
      token: props.cookies.get('token'),
      user: props.cookies.get('user'),
      loadingDialogOpen: false,
      postulated: false,
      postulation_deadline: "",
      alertDialog: false,
    }
  }

  componentDidMount(){
    this.getInformation();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar la información. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    if(new Date(this.state.postulation_deadline) <= new Date()){
      return(
        <div style={{textAlign:'center', marginTop:'20px'}}>
          <p>El periodo de postulación de proyectos ha finalizado.</p>
          <p>Muchas gracias por participar del proceso.</p>
        </div>
      )
    }
    return (
      <div style={styles.pageContainer}>
      <div>
        <h1>Portafolio de proyectos</h1>
        <Stepper step="postulation" style={{marginTop: '-20px'}} />
        {this.state.user ?
          <p style={styles.instructionsParagraph}> Debes completar los siguientes campos con la información del proyecto.
          Una vez enviada, deberás confirmar la postulación en la sección de portafolio.
          <br></br>
          En el recuadro azul podrás ver lo que fue definido por la empresa como innovación,
          recuerda que tu proyecto debe estar alineado con estos criterios para ser seleccionado.
          </p>
          :
          <p style={styles.instructionsParagraph}> Debes completar los siguientes campos con la información de tu proyecto.
            Una vez que envíes la postulación, esta será revisada por el gerente de área.
            Si queda seleccionado dentro del portafolio de innovación, serás invitado a un workshop y se te entregaran credenciales para que ingreses a la plataforma
            y llenes la ficha del proyecto.
          <br></br>
          En el recuadro azul podrás ver lo que fue definido por la empresa como innovación,
          recuerda que tu proyecto debe estar alineado con estos criterios para ser seleccionado.
          </p>
        }
        <Divider />
      </div>

      <CompanyConventions companyConventions={this.state.companyConventions} innovationDefinition={this.state.information.company.innovation_def}/>

      <PostulationFormWithSteps
        handleCheckboxChange={this.handleCheckboxChange}
        handleDateChange={this.handleDateChange}
        handleTextChange={this.handleTextChange}
        handleSelectChange={this.handleSelectChange}
        areas={this.state.areas}
        data={this.state.information}
        regex={re}
        filterData={this.state.filterData}
        />

      <div style={styles.buttonContainer}>
      {
        this.checkCompleteness() ?
        <FlatButton style={styles.button} label="AGREGAR PROYECTO" onClick={this.sendPostulation}/>
        :
        <FlatButton style={styles.redButton} label="DEBES COMPLETAR TODOS LOS CAMPOS" disabled={true}/>

      }
      </div>
      {this.state.loadingDialogOpen ? <LoadingDialog message="Estamos enviando los datos, espera un momento"/> : null}
      {this.state.alertDialog ?
        <AlertDialog
        title='¡Proyecto postulado!'
        message='Tu proyecto ha sido agregado. ¿Quieres agregar otro?'
        acceptLabel='Sí'
        cancelLabel='No'
        confirm={() => window.location.reload()}
        cancel={() => this.state.user ? this.props.history.push('/portfolio') : this.props.history.push('/portfolio/postulation/thanks')} /> :
        null }
      {this.state.alertDialogOneButton ?
        <AlertDialogOneButton
        message='Hubo problemas al agregar el proyecto, revisa los campos e intenta de nuevo'
        acceptLabel='Aceptar'
        confirm={() => this.setState({alertDialogOneButton: false})} /> :
        null }
      </div>
    );
  }

  checkCompleteness = () => {
    if(this.state.solutionType.length <= 0) return false;
    if(this.state.benefitType.length <= 0) return false;
    if(this.state.implementationDate === null) return false;
    if(this.state.name === '') return false;
    if(this.state.leaderFirstName === '') return false;
    if(this.state.leaderLastName === '') return false;
    if(this.state.leaderEmail === '' || !re.test(this.state.leaderEmail.toLowerCase())) return false;
    if(this.state.problem === '') return false;
    if(this.state.solution === '') return false;
    if(this.state.benefits === '') return false;
    if(this.state.objectives === '') return false;
    if(this.state.characteristics === '') return false;
    return true;
  }

  getInformation = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    var postulationData = connection.get(routes.projectPostulation(this.props.match.params.hash))
    var filterData = connection.get(routes.getFilters)
    Promise.all([postulationData, filterData])
    .then((responses) => {
      console.log(responses);
      this.setState({
        information: responses[0].data,
        companyConventions: responses[0].data.company_conventions,
        filterData: responses[1].data,
        loading: false,
        error: false,
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({ error: true, loading: false })
    });
  }

  handleSelectChange = (event, value) => {
    this.setState({novelty: value})
  }

  handleCheckboxChange = (type, option) => {
    var index = this.state[type].indexOf(option);
    if(index === -1){
      this.setState({[type]: [...this.state[type], option]})
    }
    else {
      this.setState((prevState) => ({
        [type]: prevState[type].filter((_,i) => i !== index)
      }));
    }
  }

  handleDateChange = (event, date) => {
    this.setState({implementationDate: date})
  }

  handleTextChange = (event, type) => {
    this.setState({[type]: event.target.value})
  }

  sendPostulation = () => {
    this.setState({loadingDialogOpen: true})
    axios({
      method: 'post',
      headers: {'Authorization': "Token "+ this.state.token},
      url: routes.host + routes.projectPostulation(this.props.match.params.hash),
      data: this.state
    })
    .then((response) => {
      this.setState({
        loadingDialogOpen: false,
        alertDialog: true
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        alertDialogOneButton: true,
        loadingDialogOpen: false
      });
    });
  }
}

export default withRouter(withCookies(ProjectPostulationView));



// WEBPACK FOOTER //
// ./src/views/postulation/ProjectPostulationView.js